import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/design/design/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Components must meet all criteria `}<em parentName="p">{`before`}</em>{` proceeding to a given milestone.`}</p>
    <h2>{`Experimental`}</h2>
    <p>{`The component exists as a proof-of-concept or is work in progress.`}</p>
    <ul>
      <li parentName="ul">{`The component may be ready for preliminary usage depending on its maturity. Please file `}<a parentName="li" {...{
          "href": "https://primer.style/contribute/how-to-contribute#contribute-to-our-open-source-repos"
        }}>{`an issue`}</a>{` to discuss further.`}</li>
    </ul>
    <h2>{`Alpha`}</h2>
    <p>{`The component is ready for preliminary usage.`}</p>
    <ul>
      <li parentName="ul">{`The component does not have external dependencies. This could be external libraries or dependencies on libraries in an application (like GitHub.com)`}</li>
      <li parentName="ul">{`The component is compatible with color modes and can adapt to different themes. The component does not reference any hard-coded static values and uses functional variables. Any temporary or app-level variables have been removed. Theme values (such as a new brand scheme) can be swapped out without touching the public API of the component.`}</li>
      <li parentName="ul">{`The component is designed with responsiveness in mind. The component can adapt to different screen sizes, from mobile to large desktop screens. The component's interactive areas must be friendly to touch on devices with a coarse pointer method.`}</li>
      <li parentName="ul">{`Component documentation includes example usage of the component.`}</li>
      <li parentName="ul">{`Primary use cases tested and reviewed.`}</li>
      <li parentName="ul">{`The component has robust unit test coverage on all critical paths, including branching logic and edge cases. This is measurable through metrics like 100% test coverage (where achievable).`}</li>
      <li parentName="ul">{`The component has visual regression coverage of its default and interactive states.`}</li>
      <li parentName="ul">{`The component has robust test coverage for its interactive (stateful) behaviour, which has been verified in end-to-end and/or open-box testing suites.`}</li>
      <li parentName="ul">{`The component does not introduce any `}<a parentName="li" {...{
          "href": "https://www.deque.com/axe/"
        }}>{`axe`}</a>{` violations.`}</li>
      <li parentName="ul">{`The component has been manually reviewed for accessibility and any outstanding issues have been fixed.`}</li>
    </ul>
    <h2>{`Beta`}</h2>
    <p>{`The component meets most maturity criteria, and use is encouraged for most scenarios.`}</p>
    <ul>
      <li parentName="ul">{`The component is used in a production application in multiple instances. Expectation is three or more instances in dotcom for Primer ViewComponents, at least one or more instances for Primer React. Uses of the component have been reviewed for correctness.`}</li>
      <li parentName="ul">{`Usage guidelines and configuration documentation covers common use cases. Implementation of additional features (secondary priorities) is expected during beta. Additional and most common use cases should be documented by this phase. Documentation should include a sandbox environment such as Storybook.`}</li>
      <li parentName="ul">{`The design has been reviewed and any resulting issues have been addressed. Systems Designers have reviewed the current implementation, validated its responsive strategy, and how it’s used in production.`}</li>
      <li parentName="ul">{`The component is compatible with server-side rendering (SSR).`}</li>
      <li parentName="ul">{`The component does not introduce unnecessary performance regressions to the user experience or the Primer library.`}</li>
    </ul>
    <h2>{`Stable`}</h2>
    <p>{`The component is significantly mature and usage is strongly encouraged, with long-term support expected.`}</p>
    <ul>
      <li parentName="ul">{`The API remains stable, with no breaking changes for at least one month. Feedback on API usability has been sought from developers using the component and production use cases have been reviewed for correctness.`}</li>
      <li parentName="ul">{`Documentation exists for the remaining implementation, usage, and design guidelines. Primer React and/or Primer ViewComponents documentation includes all props and variations, accessibility guidelines (including common misuses), and common scenarios. Design documentation is added to Interface Guidelines. Figma components are available in the Primer Web library.`}</li>
      <li parentName="ul">{`Tooling (such as linters, codemods, etc.) exists to prevent further use of alternatives.`}</li>
    </ul>
    <h2>{`Deprecated`}</h2>
    <p>{`The component will be removed in the future and should be avoided.`}</p>
    <ul>
      <li parentName="ul">{`Documentation exists for the deprecation, including any alternative components to use instead.`}</li>
      <li parentName="ul">{`When using the component, a warning is shown to the consumer.`}</li>
    </ul>
    <h2>{`Removed`}</h2>
    <p>{`The component no longer exists in Primer.`}</p>
    <ul>
      <li parentName="ul">{`The removal date has been announced and is at least one month away from the release date of the package that removes the component.`}</li>
      <li parentName="ul">{`Manual and automated migration paths are documented and have been available for at least one month.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      